import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

/**
 * Client-callable event emitter. user_id is always derived from the
 * authenticated session — never trusted from input. Used by `track()` in
 * src/lib/track.ts for browser-side events (page views, UI clicks).
 *
 * Server-side emissions (run lifecycle, IRR lifecycle, stripe webhooks)
 * call supabaseAdmin / dbProxy.insertEvent directly and do NOT route through
 * this fn — they don't have a user session bound to the request.
 */
export const recordEvent = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator(
    (input: {
      event_type: string;
      event_subtype?: string | null;
      deal_id?: string | null;
      report_id?: string | null;
      properties?: Record<string, unknown> | null;
    }) => input,
  )
  .handler(async ({ data, context }) => {
    const userId = (context as { userId: string }).userId;
    const { error } = await supabaseAdmin.from("events").insert({
      user_id: userId,
      event_type: data.event_type,
      event_subtype: data.event_subtype ?? null,
      deal_id: data.deal_id ?? null,
      report_id: data.report_id ?? null,
      properties: (data.properties ?? {}) as never,
    });
    if (error) {
      console.error("[recordEvent] insert failed", error);
      return { ok: false as const };
    }
    return { ok: true as const };
  });